import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-dark text-light px-4">
      <div className="container">
        <div className="row g-4">

          {/* Brand / About */}
          <div className="col-12 col-lg-4">
            <h5 className="fw-bold mb-3">AiW</h5>
            <p className="text-light opacity-75">
              Building modern, scalable web applications with clean architecture
              and industry-proven tools.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-6 col-lg-2">
            <h6 className="fw-semibold mb-3">Platform</h6>
            <ul className="list-unstyled">
              <li>
                <Link className="text-light opacity-75 text-decoration-none" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  className="text-light opacity-75 text-decoration-none"
                  to="/page/register"
                >
                  Register
                </Link>
              </li>
              <li>
                <Link
                  className="text-light opacity-75 text-decoration-none"
                  to="/page/login"
                >
                  Login
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="col-6 col-lg-2">
            <h6 className="fw-semibold mb-3">Resources</h6>
            <ul className="list-unstyled">
              <li>
                <Link className="text-light opacity-75 text-decoration-none" to="#">
                  Documentation
                </Link>
              </li>
              <li>
                <Link className="text-light opacity-75 text-decoration-none" to="#">
                  Support
                </Link>
              </li>
              <li>
                <Link className="text-light opacity-75 text-decoration-none" to="#">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact / Social */}
          <div className="col-12 col-lg-4">
            <h6 className="fw-semibold mb-3">Contact</h6>

            <p className="mb-2 text-light opacity-75">
              <i className="bi bi-geo-alt me-2" />
              Kumasi, Ghana
            </p>

            <p className="mb-2">
              <i className="bi bi-envelope me-2" />
              <a
                href="mailto:info@aiw.com"
                className="text-light opacity-75 text-decoration-none"
              >
                info@aiw.com
              </a>
            </p>

            <div className="d-flex gap-3 mt-3">
              <a
                href="https://www.facebook.com"
                className="text-light"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-facebook fs-5" />
              </a>

              <a
                href="https://www.linkedin.com"
                className="text-light"
                aria-label="LinkedIn"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-linkedin fs-5" />
              </a>

              <a
                href="https://www.twitter.com"
                className="text-light"
                aria-label="Twitter"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-twitter-x fs-5" />
              </a>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <hr className="border-secondary my-4" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pb-3">
          <small className="text-light opacity-75">
            © {new Date().getFullYear()} AiW. All rights reserved.
          </small>

          <small className="text-light opacity-75">
            Powered by AiW Team
          </small>
        </div>
      </div>
    </footer>
  );
}
